export const isAllObjectsEmpty = (arr: object[]): boolean => {
  return arr.every(obj => Object.keys(obj).length === 0);
};
